(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2125],{

/***/ 11262:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/reset",
      function () {
        return __webpack_require__(75351);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90690);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);




var ResetPage = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var ref;
    var query = (ref = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)()) === null || ref === void 0 ? void 0 : ref.query;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        accountActions: true,
        resetCode: (query === null || query === void 0 ? void 0 : query.resetCode) || (query === null || query === void 0 ? void 0 : query.reset)
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ResetPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(11262); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);